// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.btn_mais {
  background-color: transparent;
  border: none;
  height: 3em;
  margin-top: 2.6em;
  margin-left: 2em;
}
.caixa_novo_aluno > input {
  border: 1px solid var(--cor-cinzaMargin);
  border-radius: 0.8em;
  height: 2.5em;
  width: 97%;
  margin-bottom: 0.5em;
  font-size: large;
}
.caixa_novo_aluno > p {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}`, "",{"version":3,"sources":["webpack://./src/modais/EmprestarLivro.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,wCAAwC;EACxC,oBAAoB;EACpB,aAAa;EACb,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;AACA;IACI,iBAAiB;IACjB,oBAAoB;AACxB","sourcesContent":[".btn_mais {\n  background-color: transparent;\n  border: none;\n  height: 3em;\n  margin-top: 2.6em;\n  margin-left: 2em;\n}\n.caixa_novo_aluno > input {\n  border: 1px solid var(--cor-cinzaMargin);\n  border-radius: 0.8em;\n  height: 2.5em;\n  width: 97%;\n  margin-bottom: 0.5em;\n  font-size: large;\n}\n.caixa_novo_aluno > p {\n    margin-top: 0.5em;\n    margin-bottom: 0.5em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
